import React from "react";
import "./LocationSection.css";

const LocationSection: React.FC = () => {
  return (
    <section className="section">
      <div className="container">
        <div className="row justify-content-center text-center mb-5">
          <div className="col-md-7">
            <h2 className="heading" data-aos="fade-up">
              Standort
            </h2>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="iframe-container">
              <iframe
                title="Standort-Map"
                style={{ border: 0 }}
                referrerPolicy="no-referrer-when-downgrade"
                src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBcQBTdffiTJbdETiTQ1a335YX3MBcbqSA&q=40.72725,9.69628&zoom=15"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
